import React, { useCallback } from 'react';
import { SectionPanel } from 'ui';
import { SecondaryTextMode, TranslationsComponent } from 'app/components/translation';
import { MetroLineSection } from 'app/components/metro-line/metro-line-section';
import { ExternalUrlGroupsSectionType } from '../metroline/types';
import { languageValidationParameter, maxDescriptionLength } from '../constants';
import { ExternalUrlGroupsLanguageProps } from '../types';

export const ExternalUrlGroupsLanguage: React.FC<ExternalUrlGroupsLanguageProps> = ({
  language, longDescription, mainLanguage, languageOptions, showTranslations, validation, translation, section,
  getRef, switchTranslationsToggle, shouldRenderSection, changeLanguage, copyLanguageToAll,
  changeLongDescription, copyLongDescriptionToAll
}) => {

  const copyDescriptionToAll = useCallback(() => {
    copyLanguageToAll(mainLanguage, translation.copied_description_to_all);
  }, [mainLanguage, translation]);

  const copyLongDescription = useCallback(() => {
    copyLongDescriptionToAll(mainLanguage, translation.copied_long_description_to_all);
  }, [mainLanguage, translation]);

  return <MetroLineSection<ExternalUrlGroupsSectionType>
    section={section}
    sectionType={ExternalUrlGroupsSectionType.Translations}
    getRef={getRef}
    shouldRenderSection={shouldRenderSection}>
    <div ref={getRef(ExternalUrlGroupsSectionType.Translations)}>
      <SectionPanel
        className="admin-paper-top-panel"
        componentId={ExternalUrlGroupsSectionType.Translations}
        validation={undefined}
        info={{ text: translation.descriptions_and_translations }}
        label={{ visible: true, text: translation.descriptions_and_translations }} />
      <TranslationsComponent
        primaryText={language}
        secondaryText={longDescription}
        primaryTextValueKey={languageValidationParameter}
        secondaryTextValueKey={undefined}
        primaryTextMaxLength={maxDescriptionLength}
        secondaryTextMaxLength={4000}
        languageOptions={languageOptions}
        mainLanguage={mainLanguage}

        primaryTextLabel={translation?.description}
        copyPrimaryTextToAllLabel={translation?.copy_description_to_all}
        onPrimaryTextChange={changeLanguage}
        copyPrimaryTextToAllTranslations={copyDescriptionToAll}
        copySecondaryTextToAllTranslations={copyLongDescription}

        secondaryTextLabel={translation.long_description_title}
        copySecondaryTextToAllLabel={translation.copy_long_description_to_all}
        secondaryTextMode={SecondaryTextMode.normal}
        onSecondaryTextChange={changeLongDescription}

        translationsHeaderLabel={translation?.translations_header}
        switchTranslationsToggleLabel={translation?.show_translations}
        hasTranslationsToggled={showTranslations}
        switchTranslationsToggle={switchTranslationsToggle}
        readOnly={false}
        validation={validation?.language} />
    </div>
  </MetroLineSection>;
};
